import React, { useCallback } from 'react';
import { GridState } from '../../state';
import { FiltersMap } from '@wix/bex-core';
import { SkeletonGrid } from '../SkeletonGrid';
import { Box } from '@wix/design-system';
import { SkeletonTopImageCard } from '../SkeletonGrid/SkeletonTopImageCard';
import { SkeletonSideImageCard } from '../SkeletonGrid/SkeletonSideImageCard';
import { observer } from 'mobx-react-lite';

export interface InitialSkeletonLoaderProps<T, F extends FiltersMap> {
  dataHook?: string;
  state: GridState<T, F>;
}

function _InitialSkeletonLoader<T, F extends FiltersMap>({
  state,
  dataHook,
}: InitialSkeletonLoaderProps<T, F>) {
  const {
    toolbar: { contentPaddingPx },
    imagePlacement,
  } = state;

  const renderItem = useCallback(() => {
    return imagePlacement === 'side' ? (
      <SkeletonSideImageCard state={state} />
    ) : (
      <SkeletonTopImageCard state={state} />
    );
  }, [imagePlacement]);

  return (
    <Box
      dataHook={dataHook}
      direction="vertical"
      paddingBottom={contentPaddingPx}
    >
      <SkeletonGrid state={state} renderItem={renderItem} />
    </Box>
  );
}

export const InitialSkeletonLoader = observer(_InitialSkeletonLoader);
